export type TCountry = {
  name: string;
  code: string;
  iso: string;
  iso2: string;
};

const EGYPT: TCountry = {
  name: 'Egypt',
  code: '+20',
  iso: 'EG',
  iso2: 'EGY',
};

// Keyed by the first label of the hostname — `eg.customer.paymob.com`,
// `ksa.checkout.paymob.com`, `oman.paymob.com`. Both the short FE prefixes and
// the longer legacy ones are listed so either host style resolves.
const COUNTRY_BY_SUBDOMAIN: Record<string, TCountry> = {
  eg: EGYPT,
  egy: EGYPT,
  accept: EGYPT,
  alpha: EGYPT,
  beta: EGYPT,
  ksa: {
    name: 'Saudi Arabia',
    code: '+966',
    iso: 'SA',
    iso2: 'SAU',
  },
  sa: {
    name: 'Saudi Arabia',
    code: '+966',
    iso: 'SA',
    iso2: 'SAU',
  },
  om: {
    name: 'Oman',
    code: '+968',
    iso: 'OM',
    iso2: 'OMN',
  },
  oman: {
    name: 'Oman',
    code: '+968',
    iso: 'OM',
    iso2: 'OMN',
  },
  pk: {
    name: 'Pakistan',
    code: '+92',
    iso: 'PK',
    iso2: 'PAK',
  },
  pakistan: {
    name: 'Pakistan',
    code: '+92',
    iso: 'PK',
    iso2: 'PAK',
  },
  uae: {
    name: 'United Arab Emirates',
    code: '+971',
    iso: 'AE',
    iso2: 'ARE',
  },
  ae: {
    name: 'United Arab Emirates',
    code: '+971',
    iso: 'AE',
    iso2: 'ARE',
  },
};

export const getDomainCountry = (): TCountry => {
  const subdomain = window.location.hostname.split('.')[0].toLowerCase();
  return COUNTRY_BY_SUBDOMAIN[subdomain] ?? EGYPT;
};
